import type { SVGProps } from "react";
export interface SignatureIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function SignatureIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: SignatureIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="m21 16.875.115.006a1.125 1.125 0 0 1 0 2.238l-.115.006h-8a1.125 1.125 0 1 1 0-2.25z"
      />
      <path
        fill={color}
        d="M8.876 8V6.5a2.376 2.376 0 0 0-4.75 0V8a1.125 1.125 0 0 1-2.25 0V6.5a4.625 4.625 0 0 1 9.25 0V8l-.018 1.268-.003.069c1.33-.375 2.63-.74 3.585-1.005.22-.061.463-.129.668-.166.166-.03.469-.074.802.022l.145.052.163.077c.315.173.565.445.709.774l.063.17.036.148c.067.341-.003.64-.048.802a8 8 0 0 1-.224.65l-.38 1.014H21l.116.006a1.125 1.125 0 0 1 0 2.239l-.116.006h-4.846c-.172 0-.378 0-.553-.015a1.65 1.65 0 0 1-.768-.25 1.63 1.63 0 0 1-.697-1.006 1.66 1.66 0 0 1 .035-.808c.047-.17.121-.362.182-.523l.316-.85c-1.054.293-2.374.662-3.668 1.029-.078 1.235-.2 2.53-.398 3.518-.188.937-.462 2.6-1.106 4-.654 1.42-1.853 2.904-3.996 2.904-1.705 0-2.615-1.314-3.047-2.394-.447-1.113-.582-2.393-.579-3.235.007-1.713.699-4.54 3.77-5.564l.696-.221c.654-.2 1.532-.456 2.49-.731.009-.268.023-.525.028-.768zm-.18 4.362c-.65.189-1.229.358-1.684.498l-.656.208c-1.73.577-2.226 2.149-2.23 3.436-.004.658.111 1.628.417 2.39.318.795.662.981.958.981.855 0 1.456-.517 1.952-1.595.506-1.1.731-2.438.944-3.501.131-.658.227-1.512.3-2.417Z"
      />
    </svg>
  );
}
